import { render, staticRenderFns } from "./EntityFactCreate.vue?vue&type=template&id=0009ed04"
import script from "./EntityFactCreate.vue?vue&type=script&lang=js"
export * from "./EntityFactCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports